<template>
  <v-row v-if="chat" class="container" :class="!hideLastMessage ? 'pointer': ''" style="display: flex; justify-content: center; align-items: center; border-radius: 20px; width: 90%; position: relative">
    <Avatar :unread="messages_unread" :hide-last-message="hideLastMessage" :address="chat._id" style="margin-right: 20px;  justify-content: center; display: flex; align-items: center;" @click="goChat()" />
    <v-layout row wrap style="width: 40%" @click="goChat()">
      <v-flex v-if="isByppay" xs12 style="width: 70%">
        <b>{{ payer }} &#x21FE; {{ receiver }} (BYPPAY: {{ chat.factoring.formulaCalc.ACclc }}€)</b>
      </v-flex>
      <v-flex v-else-if="isInvoice" xs12 style="width: 70%;" class="truncate">
        <b v-if="chat.invoice.payer._id === $user._id">{{ $t('Pay') }} {{ $t('to') }} {{ receiver }} ({{ $t('ItemListChat.REMAIN') }}: {{ chat.invoice.outstandingAmmount }}€) </b>
        <b v-else-if="chat.invoice.receiver._id === $user._id">{{ $t('ItemListChat.Receive') }} {{ $t('from') }} {{ payer }} ({{ $t('ItemListChat.REMAIN') }}: {{ chat.invoice.outstandingAmmount }}€) </b>
      </v-flex>
      <v-flex v-else xs12 style="width: 70%">
        <b v-if="invited">{{ $t('ItemListChat.Invited') }}: {{ member }}</b>
        <b v-else>{{ member }}</b>
      </v-flex>
      <v-flex v-if="!hideLastMessage" xs10 class="truncate">
        <span v-if="chat.lastMessage.text !== '' && messages_unread > 0"> <strong> {{ getSystemMessage(chat.lastMessage.text) }} </strong></span>
        <span v-else-if="chat.lastMessage.text !== ''">{{ getSystemMessage(chat.lastMessage.text) }}</span>
        <span v-else-if="chat.lastMessage.file !== null && messages_unread > 0">
          <v-icon color="success">
            mdi-camera
          </v-icon> <strong> {{ $t('InvoiceChats.Foto') }} </strong></span>
        <span v-else-if="chat.lastMessage.file !== null">
          <v-icon color="success">
            mdi-camera
          </v-icon> {{ $t('InvoiceChats.Foto') }} </span>
        <span v-else>{{ $t('InvoiceChats.No messages in chat') }}</span>
      </v-flex>
    </v-layout>
    <v-row justify="end" style="display: flex; justify-content: center; align-items: center; gap: 5px">
      <v-btn
        v-if="!hideLastMessage && iAmFactoringPayer"
        class="truncate"
        style="max-width: 32px"
        color="primary"
        small
        @click="goChat(1)"
      >
        {{ $t('Pay') }}
      </v-btn>
      <v-btn
        v-if="!hideLastMessage && (invited || remindPaymentMethods || remindToPay || remindInvite)"
        class="truncate"
        style="max-width: 55px"
        color="primary"
        small
        @click="goChat(2)"
      >
        {{ $t('Remind') }}
      </v-btn>
      <v-progress-circular
        :value="progress"
        :rotate="-90"
        color="primary"
        size="60"
        style="margin-right: 10%;"
        @click="goChat()"
      >
        {{ progress }} %
      </v-progress-circular>
    </v-row>
  </v-row>
</template>

<script>
import Avatar from "./Avatar";
import {User} from "@/models/user";
import ApiRepository from "@/repositories/ApiRepository";
import Constants from "../../constants";
export default {
    name: "ItemListChat",
    components: {Avatar},
    props: {
        chat: {type: Object, default: null},
        hideLastMessage: {type: Boolean, default: false},
    },
    data () {
        return {
            isInvoice: false,
            isByppay: false,
            invited: false,
            member: "",
            payer: "",
            receiver: "",
            middle: "",
            invoice: null,
            fileName: "",
            progress: 0,
            messages_unread: 0,
            iAmFactoringPayer: false,
            remindPaymentMethods: false,
            remindToPay: false,
            remindInvite: false,
        };
    },
    watch: {
        chat: function () {
            this.fetch();
        }
    },
    async created () {
        await this.fetch();
    },
    methods: {
        async fetch () {
            this.messages_unread = 0;
            this.member = "";
            this.remindInvite = false;
            this.remindToPay = false;
            this.remindPaymentMethods = false;
            this.iAmFactoringPayer = false;
            this.invited = false;
            if (this.chat.invoice) {
                this.isInvoice = true;
                if (this.chat.factoring) {
                    if (this.chat.factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED) { //S'ha de mirar els status de factoring perque sempre surten a 3 quan els acceptes
                        if (this.$user._id.toString() === this.chat.factoring.receiver._id.toString() && this.chat.invited.length === 0 && this.chat.members.length === 3)
                            this.remindToPay = true;
                        if (this.$user._id.toString() === this.chat.factoring.middle._id.toString() && this.chat.invited.length > 0)
                            this.remindInvite = true;
                        if (this.$user._id.toString() === this.chat.factoring.payer._id.toString())
                            this.iAmFactoringPayer = true;
                    }
                    this.isByppay = true;
                    this.payer = (new User(this.chat.factoring.payer)).getSingleName();
                    this.middle = (new User(this.chat.factoring.middle)).getSingleName();
                    this.receiver = (new User(this.chat.factoring.receiver)).getSingleName();
                } else {
                    if (this.chat.invoice.status !== Constants.INVOICE.STATUS_PAYED) {
                        if (this.$user._id.toString() === this.chat.invoice.payer._id.toString() && this.chat.paymentInformation === null)
                            this.remindPaymentMethods = true;
                        if (this.$user._id.toString() === this.chat.invoice.receiver._id.toString() && this.chat.paymentInformation !== null && this.chat.invoice.status !== Constants.INVOICE.OUTSIDE_PAYMENT)
                            this.remindToPay = true;
                    }
                    this.payer = (new User(this.chat.invoice.payer)).getSingleName();
                    this.receiver = (new User(this.chat.invoice.receiver)).getSingleName();
                }
            } else {
                for (const member of this.chat.members) {
                    if (this.$user.cif !== member.cif) {
                        this.member += (new User(member)).getSingleName() + " ";
                    }
                }
                if (this.member === "") {
                    for (const invited of this.chat.invited) {
                        if (this.$user.cif !== invited.cif) {
                            this.invited = true;
                            this.member += (new User(invited)).getSingleName() + " ";
                        }
                    }
                }
            }
            if (this.chat.lastMessage.idFile !== null) {
                this.fileName = this.chat.lastMessage.idFile.originalName;
            }
            if (this.chat.invoice) {
                this.progress = this.chat.invoice.invoiceProgress;
            }
            await this.unreadMessages(this.chat);
        },
        getSystemMessage (jsonMessage) {
            try {
                const messageObject = JSON.parse(jsonMessage);
                return this.$t(messageObject.message, messageObject.params);
            } catch (e) {
                return jsonMessage;
            }
        },
        async unreadMessages (chat) {
            await ApiRepository.getMessagesFromChat(chat._id).then(res => {
                const messages = res.data.messages;
                for (let i = 0; i < messages.length; i++) {
                    const m = messages[i].viewedBy.find(element => element === this.$user._id);
                    if (m === undefined) {
                        this.messages_unread++;
                    }
                }
            });
            return this.messages_unread > 0;
        },
        goChat (button = 0) {
            if (this.$user && !this.hideLastMessage) {
                if (button === 0)
                    this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread}});
                else if (button === 1)
                    this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread, pay: this.iAmFactoringPayer}});
                else if (button === 2) {
                    if (this.invited)
                        this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread, invite: this.invited}});
                    else if (this.remindPaymentMethods)
                        this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread, remindPaymentMethods: this.remindPaymentMethods}});
                    else if (this.remindToPay)
                        this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread, remindToPay: this.remindToPay}});
                    else if (this.remindInvite)
                        this.$router.push({name: 'Chat', query: {chatId: this.chat._id, unread: this.messages_unread, inviteByppay: this.remindInvite}});
                }
            } else if (!this.hideLastMessage) {
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
            }

        },
    },
};
</script>

<style scoped>
.truncate{
  overflow:hidden;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  display: block;
}
.circle {
  border-radius: 50%;
  width: 25%;
  border: solid #00E3B4;
  color: #00E3B4;
  text-align: center;
  margin-top: 8%;
}
.circle-phone {
  border-radius: 50%;
  width: 15%;
  border: solid #00E3B4;
  color: #00E3B4;
  text-align: center;
  margin-top: 8%;
}
</style>
